export default __webpack_public_path__ + "static/media/search.8eab5bd6.svg";